import { KeyValuePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ArrayInput } from '../../models';

@Component({
    selector: 'lib-validation-array-messages',
    standalone: true,
    imports: [TranslateModule, KeyValuePipe],
    template: ` @for (e of array().errors |keyvalue; track $index) {
        <small role="alert" aria-label="Errore di validazione" class="status-{{ e['value'].status }}"
            ><strong>{{ e['value'].text | translate : e['value'].params }}</strong></small
        >
        }`
})
export class ValidationArrayMessagesComponent {
    array = input.required<ArrayInput>();
}